import Router from 'next/router'
import { use } from 'react'

import { ClientOnly } from '@/components/ClientOnly'
import { FullScreenLoading } from '@/components/FullScreenLoading'
import { GuardianLayout } from '@/components/layout/guardian'

export default function Home() {
  use(Router.replace('/web/user-setting/'))
}

Home.getLayout = (page: React.ReactNode) => (
  <ClientOnly fallback={<FullScreenLoading />}>
    <GuardianLayout>{page}</GuardianLayout>
  </ClientOnly>
)
